import YMaps from "components/YMaps"
import React from "react"
import { useTranslation } from "react-i18next"

import { Line } from "views/ContactUs/style"

const AboutForModal = () => {
  const { t } = useTranslation()

  return (
    <div className=" py-9 px-4 text-white">
      <div className="flex flex-col  justify-between gap-8">
        <div className="w-full flex flex-col justify-center">
          <h1 className="text-3xl font-bold leading-9 pb-4">
            {t("about-site")}
          </h1>
          <p className="font-normal text-base leading-6 ">
            {t("about_project")}
          </p>
        </div>
        <div className="w-full">
          <div>
            <p className="font-semibold text-white text-[32px]">
              {t("finding-in-map")}
            </p>
            <Line />
          </div>
          <div className="w-full h-[300px]">
            <YMaps />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutForModal
